'use strict';

var $ = require('jquery');

const optiTracking = require('../../components/tracking/optimizely');
const fitPredictor = require('../../components/fit-predictor');
const optiExperiment = require('../../components/optimizelyExperimentation');

exports.init = function () {
    $(window).on('load', function () {
        if ($('.message.error-form').length > 0 || $('.error-msg-inner').length > 0) {
            var offset = $('.checkout-confirmation-register .col-right').offset();
            offset.top -= 100;
            $('html, body').animate({scrollTop: offset.top});
        }

        var purchaseData = $('input[name="purchaseData"]');
        var container = $('.checkout-confirmation-register');
        var formValid = container.find('.message.error-form').length === 0;
        var passwordValid = container.find('.error-msg-inner').length === 0;

        sessionStorage.removeItem('collectionPointSelected');
        sessionStorage.removeItem('collectionPointName');
        sessionStorage.removeItem('collectionPointID');
        sessionStorage.removeItem('typeOfPoint');
        sessionStorage.removeItem('hubBox_cp');

        var orderData;
        try {
            orderData = JSON.parse(purchaseData.val());
            var totalPrice = orderData.value;
            optiTracking.pushEventToOptimizely('PURCHASE', totalPrice);
            optiExperiment.trackEvent('purchases', {revenue: String(totalPrice).replace('.', '')});
        } catch (error) {}

        fitPredictor.init('ord', orderData);
        fitPredictor.trackOrderVariants();
    });
};
